import {
	Box,
	Button,
	Card,
	CardContent,
	Checkbox,
	Container,
	Dialog,
	DialogContent,
	DialogTitle,
	Grid,
	IconButton,
	TextField,
	Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import FindInPageIcon from "@material-ui/icons/FindInPage";
import Translate from "../../../i18n/translationComponent";
import getConfig from "../../../aws-config";

const environment = getConfig();
export default function Certificates({ certificates = [], name }: any) {
	const [query, setQuery] = useState("");
	const handleOpenLink = (path: string) => {
		let link = document.createElement("a");
		link.setAttribute("href", path);
		link.setAttribute("target", "_blank");
		document.body.appendChild(link); // Required for FF

		link.click();
	};
	return (
		<Container className="dashboard-inner">
			<Grid container component="main" spacing={2}>
				{certificates.length ? (
					<>
						<Grid container component={Box} className="certificate-list">
							<Grid item xs={12} sm={6} md={6}>
								<Typography gutterBottom variant="h6" component="h6">
									Credentials Recipient: {name}
								</Typography>
							</Grid>
						</Grid>
						<Grid container component={Box} className="certificate-list">
							<Grid item xs={12} sm={4} md={4}>
								<TextField className="search-field" label="Search" variant="outlined" value={query} onChange={(e) => setQuery(e.target.value)} />
							</Grid>
						</Grid>
						<Grid container component={Box} className="certificate-list">
							{certificates
								.filter((cert: any) => {
									const searchFields = ["certificate_name", "certificate_type", "issued_dt", "issuer_name", "recipient_name"];
									console.log(cert);
									for (const field of searchFields) {
										if (String(cert[field]).toLowerCase().includes(query.toLowerCase())) {
											return true;
										}
									}
									return false;
								})
								.map((certificate: any) => {
									const previewImageUrl = `${environment.home_path}pdf/${certificate.credential_id}.jpeg`;
									return (
										<Grid item xs={12} sm={6} md={4} className="certificate" key={certificate.create_date} style={{ padding: "5px" }}>
											<div className="certificate-inner">
												<img style={{ maxWidth: "100%", width: "100%" }} src={previewImageUrl} />
												<Typography gutterBottom variant="h6" component="h6">
													{certificate.certificate_name}
												</Typography>
												<Typography gutterBottom variant="subtitle1" component="h6">
													{certificate.certificate_type}
												</Typography>
												<Typography gutterBottom variant="caption" component="h6">
													<Translate text="Issue Date" />: {certificate.issued_dt}
												</Typography>
												<Typography gutterBottom variant="caption" component="h6">
													<Translate text="By" />: {certificate.issuer_name}
												</Typography>

												<Button variant="contained" color="primary" className=" mt-20 mb-20 " onClick={() => handleOpenLink(certificate.view_url)}>
													<Translate text="View" />
												</Button>
												<Button
													variant="contained"
													color="primary"
													className="ml-20 mt-20 mb-20 success"
													onClick={() => handleOpenLink(certificate.verify_url)}
												>
													<Translate text="Verify" />
												</Button>
											</div>
										</Grid>
									);
								})}
						</Grid>
					</>
				) : (
					<div style={{ margin: "0 auto", width: "50%" }}>
						<Card style={{ padding: "40px", textAlign: "center" }}>
							<CardContent>
								<FindInPageIcon />
								<Typography>No certificates found.</Typography>
							</CardContent>
						</Card>
					</div>
				)}
			</Grid>
		</Container>
	);
}
